import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksVendorFields.PostalAddressSection', {
    header: 'POSTAL ADDRESS',
    country: 'Country',
    cityTown: 'City / Town',
    stateProvince: 'State / Province',
    address: 'Address',
    accountNo: 'Account No.',
});
